import { useState } from "react";
import { motion } from "framer-motion";
import { FaSearch } from "react-icons/fa";
import moment from "moment";
import "bootstrap/dist/css/bootstrap.min.css";

export default function Filter({ searchPayload, setSearchPayload }) {
  const [searchBy, setSearchBy] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [toggle, setToggle] = useState(false);

  const handleReset = () => {
    setSearchBy("");
    setSortBy("");
    setSortOrder("");
    setSearchPayload({
      search: "",
      sortBy: "",
      startDate: "",
      endDate: "",
    });
  };

  return (
    <div className="d-flex gap-4 z-2 position-relative align-items-center flex-column">
      <div className="d-flex justify-content-end w-100">
        <button
          onClick={() => setToggle(!toggle)}
          className="btn bg-warning text-white mb-4 fw-semibold "
        >
          <img loading="lazy" 
            width={20}
            className="me-2"
            src={`${toggle
                ? "https://img.icons8.com/color/48/delete-sign--v1.png"
                : "/filterWhite.png"
              }`}
            alt=""
          />{" "}
          Filter
        </button>
      </div>
      {toggle ? (
        <>
          <motion.div
            className="p-5 bg-white border mx-5 right-5 top-100 shadow-lg filter position-absolute rounded-5"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="row flex-column g-4">
              <div className="col-12">
                <label className="form-label fs-16">Search Products</label>
                <div className="input-group w-100 position-relative d-flex gap-2">
                  <span className="input-group-text z-1 h-100 ms-1 position-absolute border-start border-bottom border-top border-0 px-3 rounded-5 fs-12">
                    <FaSearch />
                  </span>
                  <input
                    type="text"
                    className="form-control w-100 ps-5 rounded-5 ms-2"
                    placeholder="Search products..."
                    onChange={(e) =>
                      setSearchPayload({
                        ...searchPayload,
                        search: e.target.value,
                      })
                    }
                    value={searchPayload.search}
                  />
                </div>
              </div>

              <div className="col-12">
                <label className="form-label fs-16">Search By</label>
                <select
                  className="form-select rounded-5"
                  value={searchBy}
                  onChange={(e) => {
                    const val = e.target.value;
                    setSearchBy(val);
                    if (val === "lastWeekCreated") {
                      setSearchPayload({
                        ...searchPayload,
                        startDate: moment(
                          new Date(
                            new Date().setDate(new Date().getDate() - 7)
                          ).toISOString()
                        ).format("YYYY-MM-DD"),
                        endDate: moment(new Date().toISOString()).format(
                          "YYYY-MM-DD"
                        ),
                      });
                    }
                  }}
                >
                  <option value="">Select</option>
                  <option value="lastWeekCreated">Last Week Created</option>
                </select>
              </div>

              <div className="col-12">
                <label className="form-label fs-16">Sort By</label>
                <select
                  className="form-select rounded-5"
                  value={sortBy}
                  onChange={(e) => {
                    setSortBy(e.target.value);
                    setSearchPayload({
                      ...searchPayload,
                      sortBy: e.target.value,
                    });
                  }}
                >
                  <option value="">Select</option>
                  <option value="name">Product Name</option>
                  <option value="price">Price</option>
                  <option value="offer_price">Offer Price</option>
                  <option value="quantity">Quantity</option>
                  <option value="createdAt">Date</option>
                </select>
              </div>

              <div className="col-12">
                <label className="form-label fs-16">Sort Order</label>
                <select
                  className="form-select rounded-5"
                  value={sortOrder}
                  onChange={(e) => {
                    const val = e.target.value;
                    setSortOrder(val);
                    if (val === "desc") {
                      setSearchPayload({
                        ...searchPayload,
                        sortBy: `-${sortBy}`,
                      });
                    } else {
                      setSearchPayload({ ...searchPayload, sortBy });
                    }
                  }}
                >
                  <option value="">Select</option>
                  <option value="asc">Ascending</option>
                  <option value="desc">Descending</option>
                </select>
              </div>
            </div>

            <div className="d-flex justify-content-end gap-3 mt-4">

              <button
                className="border-0 fs-16 rounded-5 text-white px-5"
                type="button"
                onClick={handleReset}
                style={{ backgroundColor: "var(--primary-color)" }}
              >
                Reset
              </button>

            </div>
          </motion.div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
}
